import { put, takeLatest, select } from 'redux-saga/effects';

import fbEmmiter from '../../../events/facebookEvents';
import { formatError } from '../../../libs';
import { Types, Creators } from '../../reducers/checkout';
import getState from '../../utils/getState';

function* selectPayment({ data }) {
  try {
    const { checkout } = yield select(getState);
    let payment = {};

    if (checkout.getIn(['payment', 'id']) !== data) {
      payment = (checkout.getIn(['payments']) || []).find((item) => item.id === data);
    }

    yield put(Creators.selectPaymentSuccess({ payment, creditCards: {}, creditCard: {}, financing: {} }));

    fbEmmiter('AddPaymentInfo');
  } catch (error) {
    yield put(Creators.selectPaymentError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SELECT_PAYMENT_REQUEST, selectPayment);
}
